import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Site, SiteSimple } from '../models/core-company-api.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoreCompanyApiService {
  constructor(private http: HttpClient) {}

  getSites(): Observable<Array<SiteSimple>> {
    const url = `${environment.vdofleet.baseApiUrl}/master-data-service/v1/sites`;
    return this.http.get<SiteSimple[]>(url);
  }

  getSitesV2(): Observable<Array<Site>> {
    const url = `${environment.vdofleet.baseApiUrl}/master-data-service/v2/sites/all`;
    return this.http.get<Site[]>(url);
  }
}
